import { styled } from '@mui/material/styles'

const getStyles = (theme) => (
  {
    root: {
      position: 'relative',
      height: 'auto',
      width: '100%',
      zIndex: 6,
      marginTop: '100vh',
      padding: '2rem 0',
      transition: '0.5s',
      backgroundColor: theme.mode === 'dark' ? '#1e1e1e' : '#fff',
      '& p, h4, h5': {
        color: 'gray'
      }
    },
    divider: {
      margin: '2rem 0'
    },
    top: {
      marginTop: '0 !important'
    },
    btnTop: {
      border: 0,
      background: 'transparent',
      position: 'absolute',
      top: '5vh',
      right: '5vh'
    },
    imgMap: {
      width: '100%',
      borderTop: `solid ${theme.palette?.primary.main} 4px`,
      marginTop: '1rem'
    },
    listDetails: {
      maxHeight: 400,
      overflow: 'auto'
    },
    listDescription: {
    },
    infoCard: {
      padding: 20
    },
    contentDeails: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      flexWrap: 'wrap',
      padding: '1rem',
      margin: '1rem 0'
    },
    bullet: {
      backgroundColor: theme.palette?.primary.main,
      width: 7,
      height: 7,
      borderRadius: '50%',
      display: 'inline-block',
      marginRight: 10,
      marginLeft: 10
    },
    infoDetailsCard: {
      width: 100,
      height: 100,
      margin: 20
    },
    icon: {
      boxShadow: '3px 2px 4px -1px #0000008c',
      borderRadius: '50%',
      padding: 5,
      margin: '0 5px'
    },
    form: {
      border: 'solid 0.5px #000',
      padding: 30,
      borderRadius: 10,
      borderLeftWidth: 1,
      borderRightWidth: 1
    },
    field: {
      width: '100%',
      marginLeft: '1rem'
    }
  }
)
const PREFIX = 'ViewerInfoStyle'
const classes = {}
const classNames = Object.keys(getStyles({}))

classNames.forEach(key => {
  classes[key] = `${PREFIX}-${key}`
})

const ViewerInfoStyle = styled('div')(({ theme }) => {
  const styles = getStyles(theme)
  const myClass = {}
  classNames.forEach(key => {
    const className = key === 'root' ? `&.${classes.root}` : `& .${classes[key]}`
    myClass[className] = {
      ...styles[key]
    }
  })
  return (myClass)
})

export {
  classes,
  ViewerInfoStyle
}
